import { render, staticRenderFns } from "./QRView.vue?vue&type=template&id=0c0552b2&scoped=true&lang=pug&"
import script from "./QRView.vue?vue&type=script&lang=js&"
export * from "./QRView.vue?vue&type=script&lang=js&"
import style0 from "./QRView.vue?vue&type=style&index=0&id=0c0552b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0552b2",
  null
  
)

export default component.exports